import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'
import toQueryString from './utils/toQueryString'

const RESOURCE_NAME = 'bandeira'
const ENDPOINT = '/gestao_bandeiras/bandeiras'

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingBandeiraSuccess(resource))
  return Promise.resolve(resource)
}

const resolveDestroy = (dispatch, id) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(destroyingBandeiraSuccess(id))
  return Promise.resolve()
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_BANDEIRA_SUCCESS = 'LOADING_BANDEIRA_SUCCESS'
export function loadingBandeiraSuccess(bandeira) {
  return {
    type: LOADING_BANDEIRA_SUCCESS,
    bandeira,
  }
}

export const DESTROYING_BANDEIRA_SUCCESS = 'DESTROYING_BANDEIRA_SUCCESS'
export function destroyingBandeiraSuccess(bandeiraId) {
  return {
    type: DESTROYING_BANDEIRA_SUCCESS,
    bandeiraId,
  }
}

export function fetchMultipleBandeira(params = {}) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(ENDPOINT + toQueryString(params)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function fetchBandeira(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(`${ENDPOINT}/${id}`).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createBandeira(bandeira) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(ENDPOINT, 'POST', bandeira).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updateBandeira(id, bandeira) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(`${ENDPOINT}/${id}`, 'PUT', bandeira).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function destroyBandeira(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return await API.call(`${ENDPOINT}/${id}`, 'DELETE').then(
      () => resolveDestroy(dispatch, id),
      error => reject(dispatch, error)
    )
  }
}

const bandeira = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_BANDEIRA_SUCCESS: {
      const { bandeira: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_BANDEIRA_SUCCESS:
      return state.delete(action.bandeiraId.toString())

    default:
      return state
  }
}

export default bandeira
